import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import firebaseConfig from './firebaseConfig';

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// Cloud Functions SDK — used by useAuth to invoke our custom magic-link
// sender (replacing Firebase's built-in, uneditable email template).
export const functions = getFunctions(app);

// Firestore with IndexedDB offline persistence.
//   • App works fully offline — reads served from cache, writes queued locally.
//   • Pending writes persist across page reloads and sync when the network returns.
//
// Walter 2026-05-18: switched from `persistentMultipleTabManager` to
// `persistentSingleTabManager`. Multi-tab keeps a shared-client-state
// record in IndexedDB that every tab coordinates against; if any tab
// is closed mid-write OR if site-data is cleared while a tab is
// running, that record corrupts and EVERY subsequent tab on the
// origin throws "FIRESTORE INTERNAL ASSERTION FAILED: Unexpected
// state" until the user fully quits the browser. Walter hit this
// after clearing site data to fix an unrelated cache desync — the
// resulting assertion bricked his desktop temporarily while his
// real life todo list was on the cloud.
//
// Single-tab manager: each tab maintains its own cache. Trade-off is
// slightly more Firestore reads if the user keeps multiple tabs
// open simultaneously (each tab syncs independently); for our
// usage pattern (one tab per device) that's invisible. The
// robustness gain is worth it: assertion cascade can't recur.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentSingleTabManager({ forceOwnership: true }),
  }),
});
